import { Segment, PointDirection, findFirstIntersectionsReversedWithCrossDirection } from "./intersection.Math";





export function computeRSIScan(data: anychart.data.Table, rsiRule:any) {
  
  console.log("calculate RSI");
  console.log(rsiRule);
//return false;;
  let period = rsiRule.period;
  let priceline = rsiRule.priceline;

  var mapping = data.mapAs();
  mapping.addField('value', 4, 'last');
  mapping.addField("dt", 0);

  // Create computer.
  var computer = data.createComputer(mapping);

  var context = anychart.math.rsi.initContext(period);

  // Set init context.
  computer.setContext(context);

  computer.setStartFunction( ctx=>{
                            anychart.math.rsi.startFunction(<anychart.math.rsi.Context>ctx);
                          });

    
    computer.setCalculationFunction(  (rowProxy:anychart.data.TableComputer.RowProxy, context:Object)=>{
        anychart.math.rsi.calculationFunction(rowProxy, <anychart.math.rsi.Context>context)
    });;

    var indicatorMapping = data.mapAs({value: computer.addOutputField('result')});
    indicatorMapping.addField("dt", 0);
    indicatorMapping.addField("close", 4);
   //mapping.addField(({value: computer.addOutputField('result')});


    var sel = indicatorMapping.createSelectable().selectAll()
    var iter = sel.getIterator();


    let xN = 0;
    let yN = 0;
    let nSegmentedline1:Segment[] = [];
    let nSegmentedline2:Segment[] = [];
    let i = 0;

    while (iter.advance()) {

      let prevx = i;
      let prevy = yN;

      i++; 
      xN = i;//iter.get("dt");

      yN = iter.get("value");

     // console.log([prevx - x]);

      nSegmentedline1.push(
                            {
                              s:{x:prevx, y:prevy},
                              e:{x:xN, y:yN}
                            }
                          )
      
      nSegmentedline2.push(
                              {
                                s:{x:prevx, y:priceline},
                                e:{x:xN, y:priceline}
                              }
                          )

                            
    }

   // console.log(nSegmentedline1);
   // console.log(nSegmentedline2);


    // let nSegmentedline1:Segment[] = [
    //     {s:{x:1,y:1},e:{x:2,y:2}},
    //     {s:{x:2,y:2},e:{x:3,y:1.5}},
    //     {s:{x:3,y:1.5},e:{x:4,y:1}},
    //     {s:{x:4,y:1},e:{x:5,y:1.5}},
    //     {s:{x:5,y:1.5},e:{x:6,y:0.5}},
    //     {s:{x:6,y:0.5},e:{x:7,y:2.5}},
    //     {s:{x:7,y:2.5},e:{x:8,y:2.5}},
    //     {s:{x:8,y:2.5},e:{x:9,y:2.5}},
    //   ]
    
    // let nSegmentedline2:Segment[] = [
    //     {s:{x:1,y:1.5},e:{x:2,y:1.5}},
    //     {s:{x:2,y:1.5},e:{x:3,y:1.5}},
    //     {s:{x:3,y:1.5},e:{x:4,y:1.5}},
    //     {s:{x:4,y:1.5},e:{x:5,y:1.5}},
    //     {s:{x:5,y:1.5},e:{x:6,y:1.5}},
    //     {s:{x:6,y:1.5},e:{x:7,y:1.5}},
    //     {s:{x:7,y:1.5},e:{x:8,y:1.5}},
    //     {s:{x:8,y:1.5},e:{x:9,y:1.5}},
    //   ]
    
    
     let firstSegmentRevIntersectionInformation:PointDirection[] | boolean = [];
     firstSegmentRevIntersectionInformation = findFirstIntersectionsReversedWithCrossDirection(nSegmentedline1,nSegmentedline2)
  //   console.log(firstSegmentRevIntersectionInformation); 

     return firstSegmentRevIntersectionInformation;

}












